// extracted by mini-css-extract-plugin
export default {"container":"root_container__wX4dX","heading":"root_heading__ZUu5b"};